<app-title-bar rootBreadCrumbs="['i18n.core.navigation.parking']" titleText="i18n.domain.parker-registration.title"></app-title-bar>
<div class="d-lg-flex align-items-center mb-2" [formGroup]="filterForm">
  <app-client-autocomplete [(selectedClient)]="selectedClient"
    class="client-autocomplete me-2"></app-client-autocomplete>
  @if (selectedClient) {
    <app-button-group class="me-2" formControlName="dataType" id="dataType" [fixedWidth]="false"
      [fieldsEnum]="ParkerRegistrationDataType"
      [translateKey]="'i18n.domain.parker-registration.data-type.'"></app-button-group>
  }
  @if (selectedClient && filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <div>
      <ejs-dropdownlist [placeholder]="'i18n.domain.parker-registration.filter.present' | translate"
        [dataSource]="presentList$ | async" [fields]="dropdownSettings" [showClearButton]="true"
        class="filter-element me-2" formControlName="present"></ejs-dropdownlist>
    </div>
  }
  @if (selectedClient && filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <div>
      <ejs-dropdownlist [placeholder]="'i18n.domain.parker-registration.filter.zones' | translate"
        [dataSource]="zoneDropdownValues" [fields]="dropdownSettings" [showClearButton]="true" class="filter-element me-2"
        formControlName="zone"></ejs-dropdownlist>
    </div>
  }
  @if (selectedClient) {
    <div>
      <ejs-dropdownlist [placeholder]="'i18n.domain.parker-registration.filter.offense-type' | translate"
        [dataSource]="statusList$ | async" [fields]="dropdownSettings" [showClearButton]="true"
        class="filter-element me-2" formControlName="offenseType"></ejs-dropdownlist>
    </div>
  }
</div>

@if (selectedClient) {
  @if (filterForm.controls.dataType.value === ParkerRegistrationDataType.Raw) {
    <app-parker-registration-raw-table #rawGrid [zones]="zones"></app-parker-registration-raw-table>
  }
  @if (filterForm.controls.dataType.value === ParkerRegistrationDataType.Evaluated) {
    <app-parker-registration-evaluated-table #evaluatedGrid [zones]="zones"></app-parker-registration-evaluated-table>
  }
}
